import React, { Component } from 'react';
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import DocumentTitle from "react-document-title";
import { setPageTitle } from '../../utils/setPageTitle';
import { BsyUtils } from '../../utils/Utils';
import { dayjsUtils } from '../../utils/dayjsUtils';

class MyModules extends Component {

    constructor(props) {
        super(props);
        this.moduleRight = React.createRef();
        this.searchVal = React.createRef();
    }

    state = {
        menuList: [],
        list: [],
        limit: 10,
        skip: 0,
        count: 0,
        backBtn: false,
        loading: false,
        id: "",
        tip: "",
        title: "",
    }

    componentDidMount() {
        React.axios('/module/module_self_type_list', {}).then((res) => {
            this.setState({
                menuList: res.data.data
            }, () => {
                this.loadList("")
                this.moduleRight.current.addEventListener('scroll', this.bindHandleScroll)
                this.searchVal.current.addEventListener("keyup", (event) => {
                    if (event.keyCode === 13) {
                        this.onSearch()
                    }
                })
            })
        })
    }

    switchType = (val) => {
        return (event) => {
            event.currentTarget.parentNode.getElementsByClassName("select")[0] && event.currentTarget.parentNode.getElementsByClassName("select")[0].classList.remove("select");
            event.currentTarget.classList.add("select");
            this.setState({
                id: val.id || "",
                list: [],
                title: val.name || "",
                skip: 0,
                backBtn: false,
                loading: false
            }, () => {
                this.loadList()
            })
        }
    }

    onSearch = () => {
        this.setState({
            list: [], skip: 0
        }, () => {
            this.loadList()
        })
    }

    backTop = () => {
        this.setState({
            backBtn: false
        }, () => {
            this.moduleRight.current.scrollTop = 0
        })
    }

    bindHandleScroll = (event) => {
        if (!event.srcElement.scrollTop) {
            return
        }
        const { skip, loading } = this.state



        const scrollTop =
            (event.srcElement ? event.srcElement.scrollTop : false) ||
            window.pageYOffset ||
            (event.srcElement ? event.srcElement.body.scrollTop : 0)
        // 视窗高度
        const clientHeight = (event.srcElement && event.srcElement.clientHeight) || document.body.clientHeight
        // 页面高度
        const scrollHeight = (event.srcElement && event.srcElement.scrollHeight) || document.body.scrollHeight
        // 距离页面底部的高度
        const height = scrollHeight - scrollTop - clientHeight

        if (scrollTop > 300) {
            this.setState({
                backBtn: true
            })
        } else {
            this.setState({
                backBtn: false
            })
        }

        if (height === 0 && !loading) {
            this.setState({
                skip: skip + 1
            }, () => {
                this.loadList()
            })
        }
    }

    loadList = () => {
        const { limit, skip, id, list } = this.state
        React.axios('/module/development_list', {
            business: id,
            key: this.searchVal.current.value,
            limit: limit,
            skip: skip * limit,
        }).then((res) => {
            let loading = false;
            if (skip === parseInt(parseInt(res.data.count) / limit)) {
                loading = true;
            }
            this.setState({
                list: list.concat(res.data.data),
                count: res.data.count,
                loading: loading,
                tip: res.data.tip
            })
        })
    }

    addclicked = false

    createModules = (event) => {
        let e = event.currentTarget
        e.style["pointer-events"] = "none";
        if (this.addclicked)
            return;
        React.axios('/module/development_create', {}).then(res => {
            e.style["pointer-events"] = "auto";

            if (res.data.code === 0) {
                window.location.href = window.rootDirectroy + "/module/development_edit/" + res.data.id
            } else {
                tipAlert({
                    type: "warning",
                    msg: res.data.msg
                })
            }
            this.addclicked = false;
        }).catch(res => {
            e.style["pointer-events"] = "none";
            this.addclicked = false;
        })
    }

    removeModules = (res, k) => {
        return () => {
            const { list } = this.state
            BsyAlert({
                title: React.language("delete.confirm", {
                    name: res.moduleName
                }),
                type: "warning",
                text4Ok: React.language("delete"),
                OkType: "red",
                text4Cancel: React.language("cancel"),
                ok: (value) => {
                    React.axios(`/module/development_delete/${res.id}`).then(res => {
                        list.splice(k, 1)
                        this.setState({
                            list
                        }, () => {
                            tipAlert({
                                type: "success",
                                msg: React.language('delete.success')
                            })
                        })
                    }).catch(res => {
                        console.error(res);
                    })
                    return true;
                }
            })
        }
    }

    leftTitle = () => {
        return <div className="leftTitle">
            <span>{React.language('my.module')}</span>
        </div>
    }

    dashboardMenuCenterMenu = () => {

    }

    render() {
        const { menuList, list, tip, loading, backBtn, title } = this.state
        setPageTitle("开放平台 - 我的插件");
        return (

            <div className="MyModules">
                <BsyDashboardMenu dashboardMenuCenterMenu={this.dashboardMenuCenterMenu} leftTitle={this.leftTitle} />
                <div className="bby-workspace-pane">
                    <div className="module-pane">
                        <div className="moduleLeft">
                            <div className="module-menu">
                                <div className="menuItem">
                                    <div className="mainNav">
                                        <div className="nav select" onClick={this.switchType("")} id="">全部</div>
                                        {
                                            menuList.map((val) => {
                                                return <div className="nav" onClick={this.switchType(val)} id={val.id}><span>{val.name}</span></div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="moduleRight" ref={this.moduleRight}>
                            <div className="moduleRightCont">
                                <div className="module-top-cont">
                                    <div className="module-top-left-cont">
                                        <div className="module-title">
                                            {!!title && <span>{title}</span>}
                                        </div>
                                        <div className="module-tip">
                                            {!!tip && <div className="mainTip">
                                                <p className="tip">
                                                    <span
                                                        title={React.language('prompt') + tip}>{React.language('prompt') + tip}</span>
                                                </p>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="module-top-right-cont">
                                        <div className="search ">
                                            <input type="text" ref={this.searchVal} placeholder={React.language('search.function.module')} />
                                            <div className="searchBtn" onClick={this.onSearch}>
                                                <i className="icon-bsy-reportmenu-0" />
                                            </div>
                                        </div>
                                        <div className="module-content-menu-btn" onClick={this.createModules}>
                                            <a className="btn">
                                                <i className="icon-bsy-add" />
                                                <span>{React.language('new.function.module')}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="module-content">
                                    <div className="content">
                                        <div className="ulList">
                                            <ul>
                                                {
                                                    list.map((val, key) => {
                                                        const createTime = BsyUtils.date2Str(dayjsUtils.timeToTZ(val.createTime), "yyyy-MM-dd HH:mm:ss");
                                                        return <li className="module-item">
                                                            <div className="item-body">
                                                                <div className="module-img">
                                                                    <img src={val.imgurl || window.rootDirectroy + "/template/formreport/static/css/resources/images/moduleExa1.png"} alt="" />
                                                                </div>
                                                                <div className="module-con">
                                                                    <div className="module-info">
                                                                        <div className="module-info-title">
                                                                            <div className="title" title={val.moduleName}>
                                                                                {
                                                                                    val.moduleName
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {!!val.description ? <div className="module-explain"
                                                                        title={React.language('module.title4') + ": " + val.description}>
                                                                        <div className="title">{React.language('module.title4')}</div>
                                                                        <div className="text">
                                                                            {val.description}</div>
                                                                    </div> : <div className="module-explain"
                                                                        title={React.language('module.title3')}>
                                                                        <div className="title">{React.language('module.title3')}</div>
                                                                    </div>}
                                                                    <div className="module-right">
                                                                        <div className="module-version">
                                                                            <div className="module-info-description"
                                                                                title={React.language('version') + val.version}>{React.language('version') + val.version}
                                                                            </div>
                                                                        </div>
                                                                        <div className="module-time">
                                                                            <div className="module-info-description"
                                                                                title={createTime}>{createTime}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="module-test" />
                                                                </div>

                                                                <div className="module-info-classification">
                                                                    <div className="type" title={React.language('module.title1') + val.type}>{React.language('module.title1') + val.type}</div>
                                                                </div>

                                                                <div className="module-btn">
                                                                    <div className="btn-item manage" onClick={() => {
                                                                        window.location.href = window.rootDirectroy + "/module/development_edit/" + val.id
                                                                    }}>
                                                                        <span>{React.language('mobile.manage')}</span>
                                                                    </div>
                                                                    <div className="btn-item remove" onClick={this.removeModules(val, key)}>
                                                                        <span>{React.language('remove')}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    })
                                                }

                                            </ul>
                                            <div className="loading-state">{loading ? React.language('module.title5') : React.language('loading')}</div>
                                        </div>
                                    </div>
                                </div>
                                {backBtn && <div className="module-top" onClick={this.backTop}
                                    title={React.language('back.top.module')}><i className="icon-bsy-iconshang" />
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default MyModules;